import { IUspBannerViewModel } from 'Types/Litium';
import Markup from 'Components/Markup';

const UspBanner = ({
    text,
    backgroundColor,
    showBannerOnMobile,
}: IUspBannerViewModel) => (
    <Markup
        style={
            {
                '--bg-color': backgroundColor,
            } as React.CSSProperties
        }
        cssClass={`${
            showBannerOnMobile ? 'flex' : 'hidden lg:flex'
        } not-prose justify-center bg-[var(--bg-color)] px-4 py-2 mb-0 !leading-4`}
        html={text?.value}
    />
);

export default UspBanner;
